import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import AddContactSteps from './AddContactSteps';

const AddContactsModal = ({
  modalSize, isOpen, toggle, handleChangeModalSize,
}) => {
  const [areYouSureModalIsOpen, setAreYouSureModalIsOpen] = useState(false);
  const onConfirmAreYouSureModal = () => {
    setAreYouSureModalIsOpen(false);
    toggle();
  };
  const onBackdropClick = () => setAreYouSureModalIsOpen(true);
  return (
    <Dialog
      open={isOpen}
      onBackdropClick={onBackdropClick}
      size={modalSize}
    >
      <DialogTitle id="dialog-title" disableTypography>
        Add Contacts
      </DialogTitle>
      <div className="sequence-create">
        <AddContactSteps toggleModal={toggle} handleChangeModalSize={handleChangeModalSize} />
      </div>
      <ConfirmationModal
        open={areYouSureModalIsOpen}
        onBackdropClick={() => setAreYouSureModalIsOpen(false)}
        title="Confirm"
        confirmLabel="Delete"
        cancelLabel="NO"
        onConfirmClick={() => onConfirmAreYouSureModal()}
        onCancelClick={() => setAreYouSureModalIsOpen(false)}
      >
          Closing this window without clicking “Save” will result in the contact not being added to the sequence.
      </ConfirmationModal>
    </Dialog>
  );
};
AddContactsModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  modalSize: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  handleChangeModalSize: PropTypes.func.isRequired,
};

AddContactsModal.defaultProps = {
  isOpen: false,
};

export default AddContactsModal;
